import React from 'react'
import { AppBar, makeStyles, Container, Toolbar } from '@material-ui/core'

const useHeaderStyles = makeStyles(() => ({
    appBar: ({ bgColor }) => ({
        backgroundColor: bgColor,
    }),
    xlContainer: {
        padding: 0,
        display: 'flex', // for IE
    },
    toolbar: ({ height }) => ({
        alignItems: 'stretch',
        width: '100%',
        minHeight: height,
    }),
}))

const Header = ({ children, bgColor, height }) => {
    const headerStyles = useHeaderStyles({ bgColor, height })
    return (
        <AppBar className={headerStyles.appBar}>
            <Container maxWidth="xl" className={headerStyles.xlContainer}>
                <Toolbar disableGutters className={headerStyles.toolbar}>
                    {children}
                </Toolbar>
            </Container>
        </AppBar>
    )
}

Header.defaultProps = {
    bgColor: '#fff',
}

export default Header
